import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Button,
  Form,
  Grid,
  Image,
  GridColumn,
  Modal,
  Header
} from 'semantic-ui-react';

import {
  changeScreen,
} from '../actions/bookPayConfirmActions';

import applePay from '../images/paymentScreen/applePay.svg';
import applePaySelected from '../images/paymentScreen/applePaySelected.svg';
import payPal from '../images/paymentScreen/payPal.svg';
import payPalSelected from '../images/paymentScreen/payPalSelected.svg';
import creditCard from '../images/paymentScreen/creditCard.svg';
import creditCardSelected from '../images/paymentScreen/creditCardSelected.svg';

class PaymentScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      creditCardStatus: creditCardSelected,
      payPalStatus: payPal,
      applePayStatus: applePay,
    }
  }

  selectMethod = method => {
    switch (method) {
      case 'paypal':
        this.setState({
          creditCardStatus: creditCard,
          payPalStatus: payPalSelected,
          applePayStatus: applePay,
        });
        break;
      case 'applepay':
        this.setState({
          creditCardStatus: creditCard,
          payPalStatus: payPal,
          applePayStatus: applePaySelected,
        });
        break;
      default:
        this.setState({
          creditCardStatus: creditCardSelected,
          payPalStatus: payPal,
          applePayStatus: applePay,
        });
    }
  }


  render() {
    return (
      <>
        <Modal.Content>
          <Grid container verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Zahlungsmöglichkeiten</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ height: '8rem' }}>
              <GridColumn width='5' floated='left'>
                <Image onClick={() => { this.selectMethod('creditcard') }} src={this.state.creditCardStatus} floated='left' />
              </GridColumn>
              <GridColumn width='6'>
                <Image onClick={() => { this.selectMethod('paypal') }} src={this.state.payPalStatus} centered />
              </GridColumn>
              <GridColumn width='5' floated='right'>
                <Image onClick={() => { this.selectMethod('applepay') }} src={this.state.applePayStatus} floated='right' />
              </GridColumn>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Kreditkartenangaben</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='9'>
                <Form.Input fluid label='Name auf der Karte' />
              </Grid.Column>
              <Grid.Column width='7'>
                <Form.Input fluid label='Kartennummer' />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width='5'>
                <Form.Input fluid label='CVV/CVC' />
              </Grid.Column>
              <Grid.Column width='5'>
                <Form.Input fluid label='Ablaufsdatum' />
              </Grid.Column>
              <Grid.Column width='6' />
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            size='large'
            color='black'
            onClick={() => { this.props.changeScreen(0) }}
            content='Zurück'
          />
          <Button
            size='large'
            color='black'
            onClick={() => { this.props.changeScreen(2) }}
            content='Jetzt zahlen'
          />
        </Modal.Actions>
      </>
    );
  }
}

export default connect(null, { changeScreen })(PaymentScreen)